import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { del } from '~lib/api/client';
import { queryClient } from '~lib/api/queryClient';
import { useToastStore } from '~store/toast';

import QueryKeys from '../queryKeys';
import { IBookmark } from './useBookmark';

export default function useDeleteBookmarks() {
  const { toastShow } = useToastStore();

  return useMutation(
    (bookmarks: string | string[]) =>
      del<AxiosResponse>('/api/user/bookmark', {
        data: { PK_NM_HASHs: bookmarks },
      }),
    {
      onSuccess: (response) => {
        const newBookmark = response.data;
        toastShow('스크랩에서 삭제되었습니다.');

        // boomark detail updater
        queryClient.setQueriesData<IBookmark[]>([QueryKeys.bookmark, 'detail'], (prev) => {
          if (prev) {
            return [...prev.filter((bookmark) => !newBookmark.includes(bookmark.PK_NM_HASH))];
          }
        });
      },
    },
  );
}
